
import { useEffect, useState } from "react";

export default function useBreakpoint() {
    const [isDesktop, setIsDesktop] = useState(
        window.innerWidth >= 1024
    );

    useEffect(() => {
        const onResize = () => {
            setIsDesktop(window.innerWidth >= 1024);
        };

        window.addEventListener("resize", onResize);

        return () => window.removeEventListener("resize", onResize);
    }, []);

    return isDesktop;
}